import {Injectable, TemplateRef} from '@angular/core';

@Injectable()
export class FooTemplatesService {

  templates: {
    [key: string]: TemplateRef<any>
  };

  constructor() {
    this.templates = {};
  }

  addTemplate(id: string, ref: TemplateRef<any>): void {
    this.templates[id] = ref;
  }

  getTemplate(id: string): TemplateRef<any> {
    return this.templates[id] || null;
  }
}
